import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const SignupPage = lazy(() => import('.'));

class SignupPageWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return [
            'privacy-sha',
            'terms-sha',
            'project-id',
            'project-name',
            'lang',
            'provider-id',
            'landing-url',
            'recaptcha-key',
        ];
    }

    render() {
        const privacySha = this.prop('privacy-sha');
        const termsSha = this.prop('terms-sha');
        const projectId = this.prop('project-id');
        const projectName = this.prop('project-name');
        const lang = this.prop('lang');
        const providerId = this.prop('provider-id');
        const landingUrl = this.prop('landing-url');
        const reCaptchaKey = this.prop('recaptcha-key');
        const phonePlaceholder = this.prop('phone-placeholder');

        return (
            <RootProviders>
                <SignupPage
                    privacySha={privacySha}
                    termsSha={termsSha}
                    projectId={projectId}
                    projectName={projectName}
                    lang={lang}
                    providerId={providerId}
                    landingUrl={landingUrl}
                    phonePlaceholder={phonePlaceholder}
                    reCaptchaKey={reCaptchaKey}
                />
            </RootProviders>
        );
    }
}

customElements.define('signup-page', SignupPageWebComponent);
